export const NAME = 'SIDEBAR';

export const SET_VISIBLE = `${NAME}/SET_VISIBLE`;
export const SIDEBAR_LOCALSTORAGE_KEY = '@admin-ng/menu-visible';
